import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class DataService {
  constructor(private readonly httpClient: HttpClient) {}

  public get<TResponse>(apiUrl: string, includeFullResponse = false, options?: any): Observable<TResponse> {
    return this.httpClient.get<TResponse>(apiUrl, options).pipe(
      map((res: any) => {
        if (includeFullResponse) {
          return res as TResponse;
        }
        return res.data as TResponse;
      })
    );
  }

  public post<TRequest, TResponse>(apiUrl: string, request: TRequest, includeFullResponse = false, options?: any): Observable<TResponse> {
    return this.httpClient.post<TResponse>(apiUrl, request, options).pipe(
      map((res: any) => {
        if (includeFullResponse) {
          return res as TResponse;
        }
        return res.data as TResponse;
      })
    );
  }

  public put<TRequest, TResponse>(apiUrl: string, request: TRequest, includeFullResponse = false, options?: any): Observable<TResponse> {
    return this.httpClient.put<TResponse>(apiUrl, request, options).pipe(
      map((res: any) => {
        if (includeFullResponse) {
          return res as TResponse;
        }
        return res.data as TResponse;
      })
    );
  }

  public putRouteObject<TResponse>(apiUrl: string, includeFullResponse = false, options?: any): Observable<TResponse> {
    return this.httpClient.put<TResponse>(apiUrl, null, options).pipe(
      map((res: any) => {
        if (includeFullResponse) {
          return res as TResponse;
        }
        return res.data as TResponse;
      })
    );
  }

  public delete<TRequest>(apiUrl: string, request: TRequest): Observable<TRequest> {
    return this.httpClient.delete<TRequest>(apiUrl, { body: request }).pipe();
  }
}
